import React, { useState } from 'react';
import { ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
import { systemFlow } from '../data/copy';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumenes" className="defer-paint w-full scroll-mt-6 bg-zinc-950 py-12 sm:py-14" aria-labelledby="volumes-heading" data-id="element-183" data-mp="7qpqa4qjcvrr">
      <div className="mx-auto max-w-4xl px-6" data-id="element-184" data-mp="3g354tcg4801w">
        <SectionHeading eyebrow="Il sistema completo" title={<span id="volumes-heading" data-id="element-186" data-mp="3c1jlp9czmpj9">
              Il sistema visuale che organizza tutto questo
            </span>} lead="6 volumi tecnici + 96 sessioni + 5 bonus esclusivi." data-id="element-185" data-mp="3c4fiuvh0ha6n" />

        <div className="mx-auto mt-8 max-w-3xl text-center" data-id="element-187" data-mp="3l2rjlqbldoct">
          <p className="font-serif text-lg font-bold leading-snug text-stone-100 sm:text-xl" data-id="element-188" data-mp="2xdyh1b0gsi98">
            Non una raccolta casuale di esercizi.
          </p>
          <p className="mt-2 font-sans text-[0.9rem] leading-relaxed text-stone-400" data-id="element-189" data-mp="2sdkgsf53uclr">
            Pallavolo 360 organizza il lavoro attraverso:
          </p>
          <ol className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-2" aria-label="La logica del sistema" data-id="element-190" data-mp="2edjxveqec5gr">
            {systemFlow.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-191" data-mp="2o4eqr1y5e3b6" data-mpi={index}>
                <span className="rounded-full border border-yellow-500/40 bg-yellow-500/10 px-3 py-1 font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-yellow-200" data-id="element-192" data-mp="2o3lhnubpv1pv">
                  {step}
                </span>
                {index < systemFlow.length - 1 ? <ArrowRightIcon className="h-3.5 w-3.5 text-yellow-500" aria-hidden="true" data-id="element-193" data-mp="20dr75jevdp8s" /> : null}
              </li>)}
          </ol>
          <p className="mt-4 font-sans text-[0.9rem] leading-relaxed text-stone-400" data-id="element-194" data-mp="24hqmhyoeyi0k">
            Apri qualsiasi volume e vai direttamente al lavoro che vuoi
            sviluppare.
          </p>
        </div>

        <ol className="mt-9 space-y-2.5" data-id="element-195" data-mp="3fxnlkfpyuibi">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          return <li key={volume.code} className={`rounded-3xl border bg-zinc-900 transition-colors duration-150 ease-out ${isOpen ? 'border-yellow-500/45' : 'border-zinc-800'}`} data-id="element-196" data-mp="1bs9dd1pzh09q" data-mpi={index}>
                <h3 data-id="element-197" data-mp="1kseggzo59ci3">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-500 sm:px-6" data-id="element-198" data-mp="1ks64rb3rcd8h">
                    <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border font-serif text-base font-bold transition-colors duration-150 ease-out ${isOpen ? 'border-yellow-500 bg-yellow-500 text-zinc-950' : 'border-yellow-500/35 bg-yellow-500/10 text-yellow-500'}`} aria-hidden="true" data-id="element-199" data-mp="16upwrv5tcbem">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-200" data-mp="2kzb841ag7pqm">
                      <span className="block font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-stone-400" data-id="element-201" data-mp="2prunn3sp4uy2">
                        Volume {index + 1}
                      </span>
                      <span className="mt-1 block font-serif text-lg font-bold leading-snug text-stone-100 sm:text-xl" data-id="element-202" data-mp="2gyhlrccnmizu">
                        {volume.name}
                      </span>
                      <span className="mt-1 block font-sans text-[11px] uppercase tracking-[0.14em] text-yellow-500" data-id="element-203" data-mp="38px5mymttrmd">
                        {volume.count}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-stone-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-204" data-mp="2zoz88z6w8icr" />
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-205" data-mp="1ob4xmxqui34f">
                  <div className="overflow-hidden" data-id="element-206" data-mp="1ysgvxn5p1a0i">
                    <div className="border-t border-zinc-800 px-5 py-5 sm:px-6" data-id="element-207" data-mp="1urf59upue6a5">
                      <div className="space-y-3" data-id="element-208" data-mp="1upapaeeo5gti">
                        {volume.intro.map(paragraph => <p key={paragraph} className="font-sans text-[0.9rem] leading-relaxed text-stone-400" data-id="element-209" data-mp="1puex9e9fmtge">
                            {paragraph}
                          </p>)}
                      </div>

                      <div className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-210" data-mp="2if561723zpj1">
                        <div className="rounded-2xl bg-zinc-800 p-4" data-id="element-211" data-mp="2dgle8q0u3jir">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-red-400" data-id="element-212" data-mp="28juyk3sxypxv">
                            Risolve
                          </p>
                          <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-stone-200" data-id="element-213" data-mp="x3del36j6fs4">
                            {volume.solves}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-yellow-500/25 bg-yellow-500/[0.07] p-4" data-id="element-214" data-mp="ryjdinoj2mz8">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-yellow-500" data-id="element-215" data-mp="wxvwgxca39wj">
                            Risultato
                          </p>
                          <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-stone-200" data-id="element-216" data-mp="15qz9j4j0hkqn">
                            {volume.result}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}